var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import StickyBox from "react-sticky-box";
var WidgetSticky = function (_a) {
    var children = _a.children, _b = _a.bottomOffset, bottomOffset = _b === void 0 ? 0 : _b, _c = _a.topOffset, topOffset = _c === void 0 ? 0 : _c, _d = _a.active, active = _d === void 0 ? false : _d, _e = _a.bottom, bottom = _e === void 0 ? false : _e, className = _a.className;
    if (!active) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsx(StickyBox, __assign({ className: className, offsetBottom: bottomOffset, offsetTop: topOffset, bottom: bottom }, { children: children })));
};
export default WidgetSticky;
